// autogen index file for audioSprite2
export const blowtorch1 = 'blowtorch1'
export const compwarn1 = 'compwarn1'
export const compwarn2 = 'compwarn2'
export const dieAlien1 = 'dieAlien1'
export const dieAlien2 = 'dieAlien2'
export const diefemale1 = 'diefemale1'
export const diefemale2 = 'diefemale2'
export const diefemale3 = 'diefemale3'
export const diefemale4 = 'diefemale4'
export const diemale1 = 'diemale1'
export const diemale2 = 'diemale2'
export const dieMale3 = 'dieMale3'
export const femaledie1 = 'femaledie1'
export const fireExtingusher1 = 'fireExtingusher1'
export const foot1 = 'foot1'
export const foot2 = 'foot2'
export const foot3 = 'foot3'
export const foot4 = 'foot4'
export const footMetal1 = 'footMetal1'
export const footMetal2 = 'footMetal2'
export const footMetal3 = 'footMetal3'
export const footMetal4 = 'footMetal4'
export const footMetal5 = 'footMetal5'
export const gunLoad1 = 'gunLoad1'
export const hammer1 = 'hammer1'
export const impact_rock = 'impact_rock'
export const maledie1 = 'maledie1'
export const money1 = 'money1'
export const pistolShoot1 = 'pistolShoot1'
export const punch1 = 'punch1'
export const punch2 = 'punch2'
export const repair1 = 'repair1'
export const repair2 = 'repair2'
export const repair3 = 'repair3'
export const teleport1 = 'teleport1'
export const zombieAttack1 = 'zombieAttack1'
export const zombieDie1 = 'zombieDie1'
export const Alarm_02_Single = 'Alarm_02_Single'
export const AlertAlarm_04_Single = 'AlertAlarm_04_Single'
export const AnalogButton = 'AnalogButton'
export const Analysis_Single_03 = 'Analysis_Single_03'
export const Button_01_Variation_01 = 'Button_01_Variation_01'
export const Button_01_Variation_02 = 'Button_01_Variation_02'
export const Button_01_Variation_03 = 'Button_01_Variation_03'
export const Button_01 = 'Button_01'
export const Button_02 = 'Button_02'
export const Negative_01 = 'Negative_01'
export const Notification_08_Variation = 'Notification_08_Variation'
export const Notification_08 = 'Notification_08'
export const Impact_Explosion_Sound_01 = 'Impact_Explosion_Sound_01'
export const Impact_Explosion_Sound_02 = 'Impact_Explosion_Sound_02'
export const Impact_Explosion_Sound_03 = 'Impact_Explosion_Sound_03'
export const Impact_Explosion_Sound_04 = 'Impact_Explosion_Sound_04'
export const Impact_Explosion_Sound_05 = 'Impact_Explosion_Sound_05'
export const DistantBigExplosion4 = 'DistantBigExplosion4'
export const FireBurningLoop1 = 'FireBurningLoop1'
export const FireBurningLoop2 = 'FireBurningLoop2'
export const FireBurningLoop3 = 'FireBurningLoop3'
export const FireExplosion7 = 'FireExplosion7'
export const FireExplosion8 = 'FireExplosion8'
export const FireExplosion9 = 'FireExplosion9'
export const Gun1 = 'Gun1'
export const Gun2 = 'Gun2'
export const Gun3 = 'Gun3'
export const MediumExplosion1 = 'MediumExplosion1'
export const MediumExplosion2 = 'MediumExplosion2'
export const MediumExplosion3 = 'MediumExplosion3'
export const MetalDebris1 = 'MetalDebris1'
export const MetalDebris2 = 'MetalDebris2'
export const MetalDebris3 = 'MetalDebris3'
export const SciFiExplosion15 = 'SciFiExplosion15'
export const SciFiExplosion16 = 'SciFiExplosion16'
export const SciFiExplosion17 = 'SciFiExplosion17'
export const SciFiExplosion21 = 'SciFiExplosion21'
export const SciFiExplosion22 = 'SciFiExplosion22'
export const SciFiExplosion23 = 'SciFiExplosion23'
export const SciFiExplosion24 = 'SciFiExplosion24'
export const SciFiExplosion25 = 'SciFiExplosion25'